import React, { PureComponent } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getSentimentColor, numberWithCommas } from "../utils";
import HighchartsCustomEvents from "highcharts-custom-events";

HighchartsCustomEvents(Highcharts);
class ProductAttributesSentimentChart extends PureComponent {
    chartComponent = React.createRef();
    state = {};

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    getOptions = () => {
        let { positive, negative, neutral } = this.props.data;

        if (this.props.expandWidget) {
            negative = negative.filter((ele) => ele.name != "Others");
            neutral = neutral.filter((ele) => ele.name != "Others");
            positive = positive.filter((ele) => ele.name != "Others");
        } else {
            {
                let negativeOther = negative.filter((ele) => ele.name == "Others");
                let neutralOther = neutral.filter((ele) => ele.name == "Others");
                let positiveOther = positive.filter((ele) => ele.name == "Others");

                positive = positive.filter((ele) => ele.name != "Others").slice(0, 9);
                positive = [...positive, ...positiveOther];

                negative = negative.filter((ele) => ele.name != "Others").slice(0, 9);
                negative = [...negative, ...negativeOther];

                neutral = neutral.filter((ele) => ele.name != "Others").slice(0, 9);
                neutral = [...neutral, ...neutralOther];
            }
        }

        // console.log("firstfirst", positive);
        let heightOfScrollBar = positive.length * 20;

        let self = this;
        const chartConfig = {
            chart: {
                type: "bar",
                //height: 150 * this.props.data.keys.length,
                // backgroundColor: "transparent",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                scrollablePlotArea: {
                    minHeight: heightOfScrollBar,
                    opacity: 1,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            xAxis: {
                type: "category",
                lineColor: "#ccd6eb",
                lineWidth: 1,
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                max: 100,
                title: "",
                labels: {
                    format: "{text}%",
                },
            },
            // legend: {
            //     enabled: this.props.showLegend,
            //     align: "center",
            //     x: 0,
            //     y: 0,
            // },
            legend: {
                enabled: this.props.showLegend,
                // width: "20%",
                // layout: "vertical",
                // align: "right",
                // padding: 3,
                // itemMarginTop: 3,
                // itemMarginBottom: 3,
                // verticalAlign: "middle",
                itemStyle: {
                    fontWeight: 500,
                    textTransform: "normal",
                },
                // alignColumns: false,
            },
            series: [
                {
                    name: "Positive",
                    data: positive,
                    dataLabels: {
                        color: "black",
                    },
                    color: getSentimentColor("positive"),
                    marker: {
                        fillColor: getSentimentColor("positive"),
                        symbol: "square",
                    },
                },
                {
                    name: "Negative",
                    data: negative,
                    dataLabels: {
                        color: "black",
                    },
                    color: getSentimentColor("negative"),
                    marker: {
                        fillColor: getSentimentColor("negative"),
                        symbol: "square",
                    },
                },
                {
                    name: "Neutral",
                    data: neutral,
                    dataLabels: {
                        color: "black",
                    },
                    color: getSentimentColor("neutral"),
                    marker: {
                        fillColor: getSentimentColor("neutral"),
                        symbol: "square",
                    },
                },
            ],
            plotOptions: {
                series: {
                    borderWidth: 0,
                    stacking: "normal",
                    dataLabels: {
                        enabled: this.props.showLabel,
                        style: {
                            fontWeight: "bold",
                            textOutline: "none",
                        },
                        formatter: function () {
                            if (this.y >= 8) {
                                return `${this.y} %`;
                            }
                        },
                    },
                },
                bar: {
                    minPointLength: 8,
                    borderWidth: 0,
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                shared: true,
                useHTML: true,
                headerFormat: "<span><b>{point.key}</b></span><br />",
                backgroundColor: "#fff",
                borderColor: "#fff",
                borderRadius: 6,

                pointFormatter: function () {
                    let toolTipData = "";
                    let topicTotal = this.totalData;
                    if (topicTotal != 0 && this.y != 0) {
                        let numVal = (this.y * topicTotal) / 100;
                        toolTipData += `<span style="border:0px solid gray;display:block;border-radius:4px;width:300px;padding:3px 1px;">
                        <span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;">
                         <span style="margin-right:4px;display:inline-block;width:8px;height:8px;background-color:${
                             this.series.color
                         };border-radius:10px" ></span> <span style="display:inline-block;width:114px;">   <b>${
                            this.series.name
                        } </b></span></span> <span style="display:inline-block;padding:1px 2px;width:42px;"><b> ${
                            // ((this.y * 100) / topicTotal).toFixed(1) + "%"
                            this.y + "%"
                        }</b> </span> <span style="display:inline-block;padding:1px"><b>(${numberWithCommas(numVal.toFixed(0))} / ${
                            this.totData
                        })</b> </span><br/> </span>`;
                    }
                    return toolTipData;
                },
                // pointFormat: '<span">{series.name}</span>: <b>{point.y}%</b> | <b>{point.doc_count}/{point.totData}</b><br/>',
                style: {
                    fontWeight: "normal",
                },
            },
        };

        return chartConfig;
    };

    render() {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default ProductAttributesSentimentChart;
